// extracted by mini-css-extract-plugin
export default {"container":"Layout_container__g96EI","content":"Layout_content__5PRRB"};